import React from 'react';
import { usePermissions } from '../../../../hooks/usePermissions';
import { PERMISSIONS } from '../../../../utils/permissions';
import { PageTitle } from '../../../atoms/PageTitle';
import { ImportJobsList } from './ImportJobsList';
import { SubmitImportList } from './SubmitImportList';

/**
 * The import batches, and for users with create:import the way to start one: a list of `CLIENT/PATIENT`
 * lines (it refreshes the list). The backoffice's uploads were removed on 2026-10-16.
 */
export function ImportsPage() {
  const { has } = usePermissions();

  return (
    <div>
      <PageTitle title="Imports" />
      {has(PERMISSIONS.CREATE_IMPORT) && <SubmitImportList />}
      <ImportJobsList />
    </div>
  );
}

export default ImportsPage;
